import React from 'react';

import { localizable } from '../../../components/Localization';

export default localizable('RejectSummary')(({ store: { message }, t }) => (
  <div>
    <h2>{t('Summary')}</h2>

    <p>
      {t('Click "Finish" to reject all offers')}
      <br />
      {t('This action cannot be undone.')}
    </p>
  </div>
));



// WEBPACK FOOTER //
// ./src/app/containers/SaleWizard/Reject/Summary.jsx